import { MpsRole } from '../models/mps-user.model';

export class MpsRoleHelper {
  static readonly USER = 'USER';
  static readonly ADMIN = 'ADMIN';
  //extra role pour HPC
  static readonly HPG = 'HPG';
  static readonly CD = 'CD';
  static readonly N17 = 'N17';

  static getRoles(): MpsRole[] {
    return [
      { id: 1, code: MpsRoleHelper.USER, label: 'User' },
      { id: 2, code: MpsRoleHelper.ADMIN, label: 'Admin' },
    ];
  }

  static findRole(roles: MpsRole[], roleCode: string): MpsRole {
    return roles.find((role: MpsRole) => role.code.toUpperCase() === roleCode.toUpperCase())!;
  }

  static getRoleIdFromCode(roleCode: string): number {
    return MpsRoleHelper.findRole(MpsRoleHelper.getRoles(), roleCode).id;
  }

  static getRoleCodeForTranslation(roleCode: string): string {
    return 'entities.roles.' + roleCode.toLowerCase().replace(/-/g, '_');
  }
}
